<template>
    <div>
        <div class="w-full h-20 bg-panels-gradient">
            <ul class="h-full flex justify-center md:justify-start overflow-x-auto">
                <li class="mx-3 md:mx-6 flex flex-row flex-none">
                    <router-link :to="{name:'invite-members', params: {vault_id: $route.params.vault_id}}" 
                        class="h-full border-b-4 border-transparent hover:border-brand no-underline whitespace-no-wrap text-grey-darkest uppercase font-semibold text-xs md:text-base flex items-center"
                        active-class="border-brand">
                        Invite
                    </router-link>
                </li>
                <li class="mx-3 md:mx-6 flex flex-row flex-none">
                    <router-link :to="{name:'invited-members', params: {vault_id: $route.params.vault_id}}"  
                        class="h-full border-b-4 border-transparent hover:border-brand no-underline whitespace-no-wrap text-grey-darkest uppercase font-semibold text-xs md:text-base flex items-center"
                        active-class="border-brand">
                        Invited Members
                    </router-link>
                </li>
            </ul>
        </div>

        <router-view></router-view>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
